import { render } from "./OutStorageRecord.vue?vue&type=template&id=2a183ebb&scoped=true"
import script from "./OutStorageRecord.vue?vue&type=script&lang=js"
export * from "./OutStorageRecord.vue?vue&type=script&lang=js"

import "./OutStorageRecord.vue?vue&type=style&index=0&id=2a183ebb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a183ebb"]])

export default __exports__